module.exports = __webpack_public_path__ + "static/media/logos_EC.539cdb22.png";